import { CHAIN_IDS } from './chain';

export const DEPRECATED_CHAIN_IDS: number[] = [
  CHAIN_IDS.SCROLL,
  CHAIN_IDS.MANTLE,
  CHAIN_IDS.ABSTRACT,
];

// Midnight Pacific.
export const CHAIN_DEPRECATION_END_DATE = new Date('2026-12-01T08:00:00Z');
export const CHAIN_DEPRECATION_END_LABEL = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  timeZone: 'America/Los_Angeles',
}).format(CHAIN_DEPRECATION_END_DATE);
